/**
 * El logo del transportista.
 *
 * 🪤 El desplegable de envíos YA sabía dibujar logos (`OptionList` con `Thumbnail`): lo que faltaba
 * era el DATO. Shalom, Olva y los demás tienen su `logo_url` cargado; **Eva y AliClik lo tienen en
 * NULL** — y salían con una inicial gris, como si fueran couriers de segunda. El archivo estaba en el
 * repo todo el tiempo (`public/couriers/_system/`).
 *
 * Así que el logo de la base MANDA (un tenant puede subir el suyo), y si no hay, se cae a los que
 * vienen con la app. Los marketplaces usan el suyo: en un pedido de Falabella el transportista ES
 * Falabella, y verlo sin logo al lado de Shalom es la clase de detalle que hace parecer improvisado
 * lo que no lo es.
 */

/** Los logos que vienen con la app, por nombre normalizado del transportista. */
export const LOGOS_INCLUIDOS: Record<string, string> = {
  aliclik: '/couriers/_system/aliclik.png',
  // Dropi (dropshipping COD) también actúa como transportista de sus pedidos. Su logo ya vive en el
  // repo (lo usa el hub de Integraciones); faltaba mapearlo acá, por eso salía con inicial gris.
  dropi: '/integrations/dropi.png',
  eva: '/couriers/_system/eva.jpg',
  // GSG (courier de Lima de Smarty Drop): el de su web, business.gsgcorp.pe (founder, 30-sep).
  gsg: '/couriers/_system/gsg.png',
  evacourier: '/couriers/_system/eva.jpg',
  shalom: '/couriers/_system/shalom.png',
  olva: '/couriers/_system/olva.svg',
  // North Express (courier de Lima de Smarty Drop): el logo dorado de su marca, sobre su negro —las letras son
  // plateadas y en blanco no se leen— (founder, 12-oct). Archivo nuevo para que no lo tape el viejo en caché.
  northexpress: '/couriers/_system/northexpress.png',
  nortexpress: '/couriers/_system/northexpress.png',
  // MERCourier (courier de Lima de Smarty Drop): su marca en blanco sobre su rojo, como su app (founder, 27-oct:
  // «coloca el logo de mercourier porque actualmente no sale»). El trazo es el logo oficial de mercourier.com.
  mercourier: '/couriers/_system/mercourier.png',
  // El transportista de un pedido de marketplace ES el marketplace.
  falabella: '/channels/falabella.png',
  mercadolibre: '/channels/mercadolibre.png',
};

/** El nombre de un transportista sin tildes, mayúsculas ni espacios: la clave de los logos. */
export const normalizarTransportista = (name: string) =>
  name.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '').replace(/[^a-z]/g, '');
const normalize = normalizarTransportista;

/**
 * El logo a mostrar: primero el que el tenant cargó, después el que trae la app.
 * `null` = no hay ninguno, y el que llama decide (una inicial, un ícono genérico).
 */
export function carrierLogo(carrierName: string | null | undefined, logoUrl?: string | null): string | null {
  if (logoUrl?.trim()) return logoUrl;
  if (!carrierName?.trim()) return null;
  return LOGOS_INCLUIDOS[normalize(carrierName)] ?? null;
}
